import { extractCareerOfferUtm, type CareerOfferUtm } from './attribution.ts';

const MAX_CONTEXT_VALUE_LENGTH = 200;

export type CareerOfferDestinationContext = {
	routing: 'manual' | 'primary_language_auto' | 'direct';
	entrypoint: 'selector' | 'promo' | 'menu' | 'direct';
	source?: 'problems_card' | 'courses_menu';
	placement?:
		| 'problems_popular_courses'
		| 'courses_menu_desktop'
		| 'courses_menu_mobile'
		| 'auth_system_banner'
		| 'community_courses_menu'
		| 'community_footer'
		| 'problems_footer';
	campaign?: string;
	creative?: string;
};

const appendUtm = (output: URLSearchParams, utm: CareerOfferUtm | null) => {
	if (!utm) return;
	for (const [key, value] of Object.entries(utm)) {
		if (value) output.set(key, value);
	}
};

const appendContext = (
	output: URLSearchParams,
	key: string,
	value: string | undefined,
) => {
	if (value) output.set(key, value.slice(0, MAX_CONTEXT_VALUE_LENGTH));
};

export const buildCareerOfferDestination = (
	pathname: string,
	searchParams: URLSearchParams,
	context: CareerOfferDestinationContext,
) => {
	const output = new URLSearchParams();
	appendUtm(output, extractCareerOfferUtm(searchParams));
	appendContext(output, 'career_offer_routing', context.routing);
	appendContext(output, 'career_offer_entrypoint', context.entrypoint);
	appendContext(output, 'career_offer_source', context.source);
	appendContext(output, 'career_offer_placement', context.placement);
	appendContext(output, 'career_offer_campaign', context.campaign);
	appendContext(output, 'career_offer_creative', context.creative);

	const query = output.toString();
	return query ? `${pathname}?${query}` : pathname;
};
